import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import AnalysisTableSection from "./AnalysisTableSection";
import { clearAnalysisTable } from "../ruleService";


const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Analysis",
        redirectTo: "/analysis",
    }
]

function AnalysisPage() {

    useEffect(() => {
        layoutService.setPageTitle('Analysis')
        layoutService.setBreadcrumbs(breadcrumbs)
        return () => clearAnalysisTable()
    }, [])

    return (
        <>
            <InfoBoxes />
            <AnalysisTableSection />
        </>
    );
}


export default withMainLayout(connect()(AnalysisPage));
